import _ from 'lodash';

export default function CustomMarkerService() {
  const service = this;

  class CustomMarkerFactory {
    constructor(markerConfig, fallback) {
      this.markerConfig = markerConfig;
      this.fallback = fallback;

      this.defaultSize = 40;
      this.defaultAnchorLat = 19;
      this.defaultLabelAnchorLat = -12;
      this.defaultAnchorLng = 42;
    }

    customMarker(map, eventName, lat, lng, options) {
      const config = _.get(this.markerConfig, eventName, {});
      const { markerLabel } = _.has(config, 'markerLabel') ? config : this.fallback;
      const { labelClass } = _.has(config, 'labelClass') ? config : this.fallback;
      const { markerData } = _.has(config, 'markerData') ? config : this.fallback;
      const marker = new MarkerWithLabel(_.assign({
        map,
        animation: google.maps.Animation.DROP,
        position: new google.maps.LatLng(lat, lng),
        labelContent: markerLabel,
        labelAnchor: new google.maps.Point(this.defaultLabelAnchorLat, this.defaultAnchorLng),
        labelClass: `custom-label-marker ${labelClass}`,
        labelInBackground: true
      }, options));
      this.setIcon(marker, markerData);
      return marker;
    }

    setIcon(marker, url) {
      const markerIcon = {
        url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(url)}`,
        scaledSize: new google.maps.Size(this.defaultSize, this.defaultSize),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(this.defaultAnchorLat, this.defaultAnchorLng)
      };
      marker.setIcon(markerIcon);
    }
  }

  service.CustomMarkerFactory = CustomMarkerFactory;
}
